import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap-5';
import classNames from 'classnames';
import { isBoolean } from 'lodash';

import { setFilterAttribute } from 'bundles/connect/components/store/actions/criteria';
import type { Criteria } from 'bundles/connect/types';

type BooleanSelectProps = {
  attribute: string;
  criteria: Criteria;
  disabled?: boolean;
  includeBlank?: boolean | string;
  setFilterAttribute: (attribute: string, value: string | null, options?: any) => { type: string } | undefined;
}
function BooleanSelect({ criteria, attribute, includeBlank, setFilterAttribute, disabled = false }: BooleanSelectProps) {
  const handleOnChange = (e) => {
    let value;

    switch (e.target.value) {
    case 'true':
      value = true;
      break;
    case 'false':
      value = false;
      break;
    }

    setFilterAttribute(attribute, value);
  };

  return (
    <Form.Select
      className={classNames('as-button', isBoolean(criteria[attribute]) ? 'active' : 'text-muted')}
      disabled={disabled}
      value={criteria[attribute]?.toString() || ''}
      onChange={handleOnChange}
    >
      {includeBlank &&
        <option value="">
          {typeof includeBlank === 'string' ? includeBlank : 'Select...'}
        </option>
      }

      <option value={'true'}>Yes</option>
      <option value={'false'}>No</option>
    </Form.Select>
  );
}

const mapStateToProps = ({ criteria }) => ({ criteria });

export default connect(mapStateToProps, { setFilterAttribute })(BooleanSelect);
